// eslint-disable-next-line no-shadow
export enum IntegrationName {
  Chainalysis_V1 = "Chainalysis V1",
  Chainalysis_V2 = "Chainalysis V2",
  Coinfirm = "Coinfirm",
  Crystal = "Crystal",
  TRM = "TRM",
  Elliptic = "Elliptic",
  Merkle_Science = "Merkle Science",
  TRM_Sanctions = "TRM Sanctions",
  Scorechain = "Scorechain",
}
